
<main class="new_pipeline">
  <div class="top_part">
    <h2 class="title">Template Management</h2>
    <div class="decision_button">
      <button class="default_secondary-btn" (click)="newTemplate()"  [ngClass]="{'text-danger': isnewTemp}">Create New</button>
      <button class="default_secondary-btn" (click)="veiwTemp()" [ngClass]="{'text-danger': !isnewTemp}">Existing Templates</button>
    </div>
  </div>
  <div class="templates">
    <div class="existing_templates" *ngIf="!isnewTemp">
      <div class="template_table" >
        <div class="the_head">
          <span class="head_item">S/N</span>
          <span class="head_item">Template Name</span>
          <p class="head_item category_detail">Template Category <span class="stage">Stages</span> <span class="task">Tasks </span></p>
          <span class="head_item">Created by</span>
          <span class="head_item">Date Created</span>
          <span class="head_item">Status</span>
          <span class="head_item">Action</span>
        </div>
        <div class="the_row" *ngFor="let template of templates; index as i">
          <span class="row_item">{{i + 1}}</span>
          <span class="row_item">{{template.PipelineTemplateName}}</span>
          <span class="row_item">

            <ul class="category_list">
              <li class="category category_detail" *ngFor="let cat of stagecategories">
                <span (click)="templateView(template.id, cat.id)"> {{cat.PipelineLicenseCategoryName}} </span>
                
                  <span style="color:black">{{filterStage(cat.id, template.id).length}}</span>
                  <span style="color:black">{{countTask(cat.id, template.id)}}</span>
                
              </li>  
            </ul>
          </span>

          <span class="row_item">{{template.CreatedByName}}</span>
          <span class="row_item">{{template.dateCreated | date}}</span>
          <span class="row_item status" style="color: blue; cursor: pointer;"  (click)="changStatus(template)">{{template.Status}}</span>
          <div><span class="row_item" *ngFor="let cat of stagecategories" style="color: blue; cursor: pointer;" title="{{cat.PipelineLicenseCategoryName}}" (click)="templateView(template.id,  cat.id)" >View</span></div>
        </div>
      </div>
    </div>

    <div class="new_template" *ngIf="isnewTemp" [formGroup]="templateForm">
      <div class="hold_form">
        <h2 class="heading">Create New Template</h2>
        <div class="the_input">
          <label for="">Template Name</label>
          <input type="text" class="default_input" formControlName="PipelineTemplateName" />
        </div>

        <button class="default_primary-button" *ngIf="templateForm.valid"  (click)="onSubmitTemplate(templateForm.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>